document.addEventListener('DOMContentLoaded', () => {
  const scrollBtn = document.querySelector('.testimonials-scroll-btn');
  if (!scrollBtn) return;

  const targetSection = document.getElementById('testimonials-section');
  if (!targetSection) return;

  scrollBtn.addEventListener('click', () => {
    const headerOffset = 80;
    const elementPosition = targetSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  });
});
